

export const AppConstant = {
    Tenant: "testing",
    varsion: 1.00,
    Appcolororange:"#ff6500",
    Appcolorblue:"#121e4b",
}